var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{attrs:{"id":"footer"},on:{"click":_vm.hideFooter}},[_c('p',{staticClass:"copyright"},[_vm._v(" Copyright©2023 SANDEN RETAIL SYSTEMS CORPORATION All Rights Reserved. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }